<template>
  <ElDialog
      v-model="isShow"
      :title="$t('label.btn.add')"
      :footer="null"
      centered
      :width="450"
      destroyOnClose
      @cancel="close"
  >
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        @submit.prevent
        style="width: 420px;"
        label-width="90"
    >
      <el-form-item :label="$t('label.col.table.1')" prop="name">
        <el-input
            @keyup.enter.prevent="createConfirm"
            :placeholder="$t('common.please.input')"
            size="small"
            v-model="ruleForm.name" maxlength="30"
            show-word-limit/>
      </el-form-item>
      <el-form-item :label="$t('label.col.table.3')" prop="remark">
        <el-input @keyup.enter.prevent="createConfirm"
                  show-word-limit
                  type="textarea"
                  maxlength="100"
                  rows="2"
                  :placeholder="$t('common.please.input')" size="small"
                  v-model="ruleForm.remark"/>
      </el-form-item>
    </el-form>
    <div class="fx-j-c">
      <ElButton size="small" type="primary" @click="createConfirm" :loading="isLoading">{{
          $t("common.confirm")
        }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {V2CreateTeam} from '../../api'
import {ref, defineProps, watch, defineEmits, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import {i18n} from "@/lang";
import {mailCustomerLabelAdd, mailCustomerLabelEdit} from "@/api/customer";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false)


const {value, flagType, isEdit, currentRow} = defineProps({
  value: {type: Boolean, default: false},
  flagType: {type: Number, default: 0},
  isEdit: {type: Boolean, default: false},
  currentRow: {
    type: Object, default: {}
  }
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})

watch(() => flagType, (val) => {
//   数据重置，表单重置
})

const ruleForm = ref({
  name: "",
  remark: "",
})

const rules = ref(
    {
      name: [{required: true, message: i18n.global.t('add.tab.form.name'), trigger: ['blur', 'change']}],
    }
)

const ruleFormRef = ref()
const teamId = computed(() => store.state.email.teamID);
const isLoading = ref(false)
const createConfirm = async () => {
  ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      if (!isEdit) {
        // 添加
        const payload = {
          labelType: flagType,
          teamId: teamId.value,
          remark: ruleForm.value.remark,
          labelName: ruleForm.value.name
        }
        console.log(payload, 'payload')
        isLoading.value = true
        const res = await mailCustomerLabelAdd(payload)
        if (res.code === 200) {
          isLoading.value = false
          ElMessage.success(res.message)
        } else {
          isLoading.value = false
          ElMessage.error(res.message)
        }
        close()
        emit("getList")
      } else {
        //  编辑
        const payload = {
          id: currentRow?.id,
          labelType: currentRow?.labelType,
          teamId: teamId.value,
          remark: ruleForm.value.remark,
          labelName: ruleForm.value.name
        }
        isLoading.value = true
        const res = await mailCustomerLabelEdit(payload)
        if (res.code === 200) {
          isLoading.value = false
          ElMessage.success(res.message)
        } else {
          isLoading.value = false
          ElMessage.error(res.message)
        }
        close()
        emit("getList")
      }
    } else {

    }
  })
}
const close = () => {
  emit("close");
}

onMounted(() => {
  if (isEdit) {
    console.log(currentRow, 'currentRow')
    ruleForm.value.name = currentRow.labelName;
    ruleForm.value.remark = currentRow.remark;
  } else {
    ruleForm.value.name = ""
    ruleForm.value.remark = ""
  }
})
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
}
</style>
